export const SENTRY_DSN = 'https://76a3a7b51ee642599ca2c6268aff20c8@o474997.ingest.sentry.io/5512286'
